import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { post } from '../../http';

export type MlifeActivationRequest = {
  login: string;
  email?: string;
  birthday: string;
  dateOfBirth?: string;
  credentials?: {
    password: string;
  };
  mlifeNumber?: string;
  activationKid: string;
  activationCode?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  fName?: string;
  lName?: string;
  creditAccount?: boolean;
  address?: {
    street1: string;
    street2?: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
  };
};

export type MlifeVerificationCodeRequest = {
  login: string;
  activationKid: string;
  activationCode?: string;
};

export const mlifeVerificationCodeRequest = async (requestBody: MlifeVerificationCodeRequest) => {
  try {
    const result = await post('/guest/verifyCode', {
      body: JSON.stringify(requestBody),
    });

    evaluateResponseErrorCode(result.response);

    return result.response;
  } catch (error) {
    throw getApiError(error);
  }
};
